const amenitiesApi = ({ apiClient }) => ({
  list(params = {}) {
    return apiClient.get('amenities', {}, params, {})
  },

  listGroups(params = {}) {
    return apiClient.get('amenities/groups', {}, params, {})
  },

  storeGroup(payload) {
    return apiClient.post('amenities/groups', payload, false, {})
  },

  updateGroup(id, payload) {
    return apiClient.put(`amenities/groups/${id}`, payload, {})
  },

  showGroup(id, param = {}) {
    return apiClient.get(`amenities/groups/${id}`, {}, param, {})
  },

  deleteGroup(id) {
    return apiClient.delete(`amenities/groups/${id}`, {})
  },

  importIconFromCdn(externalId) {
    return apiClient.post('amenities/icons/from-cdn', { external_id: externalId }, false, {})
  },

  updateIcon(amenityId, payload) {
    return apiClient.put(`amenities/${amenityId}/icon`, payload, {})
  },

  getIcon(amenityId) {
    return apiClient.get(`amenities/${amenityId}/icon`, {}, {}, {})
  },
})

export default amenitiesApi
